
import { defineComponent, ref, onMounted } from "vue"


import Cucc from './Cucc.vue'
import Cmcc from './Cmcc.vue'


export default defineComponent({
    name: 'ProtocolDialog',
    components: {
        Cucc,
        Cmcc,
    },
    props: {
        type: {
            type: String,
            default: "",
        },
    },
    setup(props, ctx) {
        const showCucc = ref(false)
        const showCmcc = ref(false)
        const show = ref(true)

        onMounted(() => {
            console.log('setup when protcol with type:', props.type)
            if (props.type.indexOf('cucc') >= 0) {
                showCucc.value = true
            }
            if(props.type.indexOf('cmcc') >=0) {
                showCmcc.value = true
            }
        })

        const clickOuter = () => {
            onCuccClose()
        }

        const onCuccClose = () => {
            show.value = false
            ctx.emit('onClose', {})
        }
        return {
            show,
            showCucc,
            showCmcc,
            onCuccClose,
            clickOuter,
        }
    },
})
